import {
  AUTHENTICATION_URL,
  BASE_URL,
  PROJECT_STATUSES,
} from "../src/constants/constants";
import {getProjectStatus} from "../src/utils";

export const getProjectDetailService = (id) => {
  return fetch(`${BASE_URL}/api/projects/${id}?populate=%2A`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
  })
      .then((response) => {
        return response;
      })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
};

export const getAllProject = () => {
  return fetch(`${BASE_URL}/api/projects/?populate=%2A`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: AUTHENTICATION_URL,
    },
  })
      .then((response) => {
        return response;
      })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.log(error);
      });
};

const requestOptions = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    Authorization: AUTHENTICATION_URL,
  },
  redirect: "follow",
};

export const getProjectListingService = async (address,pageNumber = 1, pageSize = 10) => {
  let endpointURL = `${BASE_URL}/api/projects?filters[deployer][$eq]=${address}&sort[0]=createdAt%3Adesc&publicationState=preview&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}`;
  const result = await fetch(endpointURL, requestOptions);
  const response = await result.json();
  response.data.forEach(project => {
    if(!project.attributes.publishedAt) {
      project.attributes.project_status =  PROJECT_STATUSES.DRAFT
    } else {
      let { project_start_time, project_end_time } = project.attributes;
      project.attributes.project_status  = getProjectStatus(project_start_time, project_end_time)
    }
  });
  let pagination = response.meta.pagination;
  return { projects: response.data, pagination};
}

export const fetchProjects = async (status, pageNumber = 1, pageSize = 12) => {
  let current = new Date().toISOString();

  let upcomingEndpointURL = `${BASE_URL}/api/projects?filters[project_start_time][$gt]=${current}&[sort]=project_start_time:desc`;
  let completedEndpointURL = `${BASE_URL}/api/projects?filters[project_end_time][$lt]=${current}&[sort]=project_end_time:desc`;
  let liveEndpointURL = `${BASE_URL}/api/projects?filters[$and][0][project_start_time][$lt]=${current}&filters[$and][1][project_end_time][$gt]=${current}&[sort]=project_end_time:asc`;
  let featuredProjects = `${BASE_URL}/api/projects?filters[featured][$eq]=true&[sort]=project_start_time:desc`;

  let endpointURL;

  switch(status){
    case PROJECT_STATUSES.UPCOMING:
      endpointURL = upcomingEndpointURL;
      break;
    case PROJECT_STATUSES.LIVE:
      endpointURL = liveEndpointURL;
      break;
    case PROJECT_STATUSES.COMPLETED:
      endpointURL = completedEndpointURL;
      break;
    case null:
    case undefined:
      endpointURL = featuredProjects;
      break;
  }

  endpointURL +=`&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&populate=*`;

  const result = await fetch(endpointURL, requestOptions);
  const response = await result.json();
  let dataMakingArray = response.data.map((project) => {
    let projects = {
      id: project.id,
      ...project.attributes,
      project_status: status,
    }
    if(!status){
      projects.project_status = getProjectStatus()
    }
    return projects
  })
  return { data: dataMakingArray, meta: response.meta };
};
